<template>
  <MessengerForm :typeEndPoint="'MessengerShow'" :dataParams="this.$route.params" />
</template>
<script>
import MessengerForm from '@/components/modules/schoolroutes/messenger/form'
export default {
  name: 'MessengerFormEdit',
  components: {
    MessengerForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/schoolroutes/messenger/edit.vue